<style lang="scss">
	.recommanded{
		margin-top: 30px;
        .widget-title{
            color: #ff5b94;
            font-family: Poppins;
            font-size: 30px;
            font-weight: 600;
            text-transform: uppercase;

            &--small {
                font-size: 20px;
            }
        }

        &--no-top-margin {
            margin-top: 0;
        }

		.page-divider {
			border-bottom: 1px solid;
            margin-bottom: 30px;
		}
	}
	.license-drawer {
        overflow: auto;
        text-align: center;
        transition: max-height 0.15s ease-out;

        .license-box-container {
            display: flex;
            flex-wrap: wrap;
            align-items: stretch;
        }
        .license-box-wrapper {
            flex-grow: 1;
            width: 120px;
        }
        .license-box {
            text-align: center;
            height: 50px;
            cursor: pointer;
            position: relative;
            z-index: 99;
            font-size: 12px;
            color: #fff;
            border: 0px;
            border-radius: 2px;
            margin: 5px;
            padding-left: 5px;
            padding-right: 5px;

            .license-name {
            padding: 4px 0px;
            font-size: 11px;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: 18px;
            }

            .license-price {
            line-height: 25px;
            font-size: 20px;
            font-weight: bold;
            }

            .license-name, .license-price {
            color: #fff;
            }
        }

        .license-box-saleable-offer {
            .license-name {
            padding-top: 2px;
            }

            .license-price {
            font-size: 11px;
            line-height: 13px;
            }

            .offer {
            font-size: 11px;
            }
        }

        .license-box-offer-only {
            .name {
            padding-top: 4px;
            }

            .license-price {
            display: none;
            }

            .offer {
            font-weight: bold;
            font-size: 14px;
            line-height: 25px;
            }
        }

        .license-box-in-cart {
            position: relative;
            box-sizing: border-box;

            .license-box-tab {
            display: block;
            border-color: transparent;
            border-style: solid;
            border-radius: 2px;
            border-width: 10px;
            position: absolute;
            top: 0;
            right: 0;
            }
        }
    }
</style>

<template>
    <div class="recommanded" :class="{'recommanded--no-top-margin': noTopMargin}" v-if="show && recommendedBeats.length">
        <h3 class="widget-title" :class="{'widget-title--small': smallTitle}" :style="$highlightColor">OTHER BEATS YOU MAY LIKE</h3>
        <template>
            <div class="row" >
                <beat-container class="beats col-md-3 col-xs-6 col-sm-6" :showDownload="true" :showPrice="true" v-for="beat in recommendedBeats" :key="beat.id" :beat="beat" :image-size="300"></beat-container>
            </div>
        </template>
    </div>
	
</template>

<script>
	import BeatContainer from './beatcontainer.vue'
    import Configure from './../mixins/configure'
    import Beat from './../models/beat'

    export default {
        props: {
            'show': {
                type: Boolean,
				default: true
            },
            'smallTitle': {
                type: Boolean,
                default: false,
            },
            'noTopMargin': {
                type: Boolean,
                default: false,
            }
        },
		components: {
            BeatContainer
        },
		data() {
			return  {
				loading : true,
			}
		},
		mixins: [Configure],
		computed : {
			recommendedBeats() {
				return this.$store.state.recommendedBeats
			},
            playlistManager() {
                return this.$store.state.playlistManager
            },
		},
		methods: {
			getRecommendedBeats() {
			    const loggedInUser = this.$store.state.loggedInUser;
				if(loggedInUser.token){
					this.$http.get(`${ab.apiUrl}/html5/recommended`, {
						params: {
							'api_token': loggedInUser.token,
							'producerId': ab.user.id,
							'limit' : 4
						}
					}).then((response) => {
						this.loading = false
						if(response.data.items.length > 0){
							this.$store.commit("recommendedBeats", {recommendedBeats: Beat.makeArray(response.data.items)})
							let playlist = this.playlistManager.getPagePlaylist();
							playlist.addPlaylistItems(Beat.makeArray(response.data.items));
						}
					}).catch((error) => {
						this.loading = false
					});
				}else{
					this.$store.commit("recommendedBeats", {recommendedBeats: []})
				}
				
			}
		}, 
		watch: {
			show: {
				handler : function(val){
					if (val) {
						this.getRecommendedBeats()
					}
				},
				immediate: true
			}
		}
	}
</script>